<template>
<div>
      <div class="biaodan" :class="[{'biaodanDonghua':changeshowform}]"><img src="../assets/landMb/dibu_biaodan.png" /></div>
      <div class="wrapContainer1">
        <div  class='bannerForm' :class="[{'esilice':changeshowform},'wrapContainer',hasValidate?'validate':'']">
          <div class="formcontainer">
      <div class="inputName">
        <!-- <div class="inpname">姓名:</div> -->
        <input type="text" placeholder="姓名"  v-model="name" :class="name?'':'error'"/>
      </div>
      <div class="inputPhone">
        <!-- <div class="inpname">手机:</div> -->
        <input type="text" placeholder="手机"   v-model="tel" :class="tel?'':'error'"/>
      </div>
      <div class="inputCity">
        <!-- <div class="inpname">城市:</div> -->
        <input type="text" placeholder="城市"  v-model="address" :class="address?'':'error'"/>
      </div>
      <div class="inputTlak">
        <!-- <div class="inpname">留言:</div> -->
        <input type="text" placeholder="留言"   v-model="message"/>
      </div>
      <div class="quantao" @click="validate">
        <div>一键领取全套方案</div>
      </div>
    </div>
          </div>
      <div class="jiantou" :class="[{'jiantouPosition':changeshowform}]" @click="closeForm"><span v-if="arrow" class="bgarrowLeft"></span><span v-else class="bgarrowRight"></span></div>
  </div>
</div>
</template>

<script>
import {serviceUrl,AddPartnerInfo} from "../config/getData";
import Bus from '../config/bus';
// import { setTimeout } from 'timers';
export default {
  data() {
    return {
    changeshowform:false,
    arrow:true,
    name: null,
    tel: null,
    address: null,
    message: null,
    isClick:true,
    hasValidate: false,
    partnerid:0
    };
  },
  mounted(){
      if(this.GetUrlParam("partnerid")){
      this.partnerid = this.GetUrlParam("partnerid");
    }
  },
  methods:{
     GetUrlParam(paraName){
　　　　let url = document.location.toString();
        let arrObj = url.split("?");
　　　　if (arrObj.length > 1) {
          let arrPara = arrObj[1].split("&");
          let arr;
　　　　　　for (let i = 0; i < arrPara.length; i++) {
　　　　　　　　arr = arrPara[i].split("=");
　　　　　　　　if (arr != null && arr[0] == paraName) {
　　　　　　　　　　return arr[1];
　　　　　　　　}
　　　　　　}
　　　　　　return "";
　　　　}
　　　　else {
　　　　　　return "";
　　　　}
　　},
    closeForm(){
      this.changeshowform=!this.changeshowform
      this.arrow=!this.arrow
    },
     validate: function(event) {
      const { name, tel, address, onSubmit, message } = this;
      this.hasValidate = true;
      // if(!this.tel){
      //   Bus.$emit("showalert", 0);
      // }
      if (!name || !tel || !address) {
        Bus.$emit("showalert", 0);
      // }
        return;
      }
      let myreg = /^[1][3,4,5,7,8,6,9][0-9]{9}$/;
      if (!myreg.test(this.tel)) {
        this.tel = "";
        return false;
      }
      if (this.isClick) {
        this.isClick = false;
        let data = {
          name: this.name,
          mobile: this.tel,
          region: this.address,
          message: this.message,
          partnerid:this.partnerid
        };
        AddPartnerInfo(data)
          .then(res => {
            if (res.data.Code === 200) {
              this.SuccessfulReception = true;
              this.isClick = true;
              this.name='';
              this.tel='';
              this.address='';
              this.message='';
              Bus.$emit("showalert", 1);
            }
            // setTimeout(()=>{
            //   Bus.$emit("showalert", false);
            // },3000)
          })
          .catch(error => {
            this.isClick = true;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// .slide-fade-enter-active {
//   transition: all .3s ease;
// }
// .slide-fade-leave-active {

// }
// .slide-fade-enter, .slide-fade-leave-to{
//   width: vp(416);
// }
// .widtharrow{
  
// }
//    .validate {
//   input.error {
//     border: 1px solid #333333 !important;
//   }
// }
@media screen and (max-width: 998px) {
  .wrapContainer1{
    display: none;
  }
  .biaodan{
    display: none;
  }
}
.wrapContainer1{
  position: fixed;
  z-index: 999;
}
.wrapContainer{
  transition: width 1s;
  overflow: hidden;
  position: fixed;
  width: 100vw;
  height: vp(65);
  bottom: 0;
  z-index: 999;
  &.esilice{
    width: vp(400);
  }
}
.biaodan {
    position: fixed;
    left: vp(382);
    bottom: 0;
    z-index: 1000;
    transition: all 1s;
    img {
      display: block;
      width: vp(169);
      height: vp(183);
    }
  }
.biaodanDonghua{
    position: fixed;
    left: vp(193);
    bottom: 0;
    z-index: 1000;
}
.bannerForm {
  height: vp(65);
  background: #e1251b;
  width: vp(1493);
  box-sizing: border-box;
  padding-top: vp(17);
  .formcontainer{
    width: vp(946);
    margin-left: vp(568);
    display: flex;
  }
  .inputName{
    color: #ffffff;
    font-size: vp(20);
    font-family: "SHS-R";
    position: relative;
    .inpname{
      position: absolute;
      top: vp(1);
      font-family: "SHS-R";
      margin-left: vp(8);
      font-size: vp(18);
      height: vp(33);
      line-height: vp(33);
    }
    input{
    // padding-left: vp(55);
    padding-left: vp(10);
    outline: none;
    width: vp(116);
    height: vp(33);
    box-sizing: border-box;
    background:  #e1251b;
    border-radius: vp(16);
    color: #ffffff;
    border: 1px solid #ffffff;
    }
    input::placeholder{
      color: #FFFFFF;
      font-size: vp(16);
    }
  }
  .inputPhone{
    color: #ffffff;
    font-size: vp(20);
    font-family: "SHS-R";
    position: relative;
    margin-left: vp(17);
    .inpname{
      font-family: "SHS-R";
      font-size: vp(18);
      margin-left: vp(8);
      height: vp(33);
      line-height: vp(33);
      top: vp(1);
      position: absolute;
    }
    input{
    padding-left: vp(10);
    outline: none;
     width: vp(157);
    height: vp(33);
    box-sizing: border-box;
    background:  #e1251b;
    border-radius: vp(16);
    height: vp(33);
    border: 1px solid #ffffff;
    color: #ffffff;
    }
    input::placeholder{
      color: #FFFFFF;
      font-size: vp(16);
    }
  }
  .inputCity{
    color: #ffffff;
    font-size: vp(20);
    font-family: "SHS-R";
    position: relative;
    margin-left: vp(17);
    .inpname{
       position: absolute;
       font-family: "SHS-R";
      font-size: vp(18);
      margin-left: vp(8);
      line-height: vp(33);
      height: vp(33);
      top: vp(1);
    }
    input{
    padding-left: vp(10);
    width: vp(132);
    height: vp(33);
    outline: none;
    box-sizing: border-box;
    background:  #e1251b;
    border-radius: vp(16);
    color: #ffffff;
    border: 1px solid #ffffff;
    }
    input::placeholder{
      color: #FFFFFF;
      font-size: vp(16);
    }
  }
  .inputTlak{
    margin-left: vp(17);
    height: vp(33);
    color: #ffffff;
    font-size: vp(20);
    font-family: "SHS-R";
    position: relative;
    .inpname{
      position: absolute;
       font-family: "SHS-R";
      font-size: vp(18);
      margin-left: vp(8);
      line-height: vp(33);
      height: vp(33);
      top: vp(1);
    }
    input{
    padding-left: vp(10);
    outline: none;
    width: vp(174);
    box-sizing: border-box;
    background:  #e1251b;
    border-radius: vp(16);
    height: vp(33);
    border: 1px solid #ffffff;
    color: #ffffff;
    }
    input::placeholder{
      color: #FFFFFF;
      font-size: vp(16);
    }
  }
  .quantao{
    width: vp(193);
    height: vp(33);
    line-height: vp(33);
    color:#ffffff;
    border: vp(1) solid #ffffff;
    text-align: center;
    border-radius: vp(16);
    margin-left: vp(71);
    cursor: pointer;
    font-size: vp(20);
  }
}
  .jiantou{
    color: #ffffff;
    height: vp(65);
    font-size: vp(50);
    z-index: 9999;
    cursor: pointer;
    background: #e1251b !important;
    border-left: 2px solid #ffffff;
    width: vp(390);
    padding-left: vp(18);
    padding-right: vp(6);
    position: fixed;
    left: vp(1493);
    bottom: 0;
    transition: all 1s;
  }
  .jiantouPosition{
    width: vp(20);
    position: fixed;
    left:vp(400);
}
.bgarrowLeft{
  display: inline-block;
  background: url("../assets/image/homePage/index/PhoneImage/arrow.png");
  height: vp(40);
  background-size: 100%;
  background-repeat: no-repeat;
  width: vp(20);
}
.bgarrowRight{
  display: inline-block;
  background: url("../assets/image/homePage/index/PhoneImage/arrow.png");
  transform: rotate(180deg);
  background-repeat: no-repeat;
  background-size: 100%;
  height: vp(40);
  width: vp(20);
}
</style>



// WEBPACK FOOTER //
// src/components/PartnerForm.vue